import { environment } from "@environments/environment";

export const getS3Url = (url: string) => {
    const newImageUrl = environment.attachmentUrl + url;
    return newImageUrl + '?' + Date.now().toString();
}

export const removeDomainFromUrl = (url: string): string => {
    const urlObj = new URL(url);
    return urlObj.pathname + urlObj.search + urlObj.hash;
  }